import { faCircle as farCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import assetUrl from 'mk/common/assetUrl';
import FormControl from 'mk2/components/forms/FormControl';
import { isSameValue, valueStr } from 'mk2/components/forms/SelectField';
import Img from 'mk2/components/Img';
import React from 'react';
import { Field, WrappedFieldInputProps, WrappedFieldProps } from 'redux-form';
import styles from './RadioField.mscss';

export interface RadioOption {
    value: string | number;
    label: string;
    image?: string;
}

interface RadioInputPublicProps {
    options: RadioOption[];
    horizontal?: boolean;
}

type RadioInputProps = RadioInputPublicProps  & {
    hasLabel: boolean;
    input: WrappedFieldInputProps;
};

class RadioInput extends React.Component<RadioInputProps> {
    public render() {
        const { options, input, hasLabel, horizontal } = this.props;

        return (
            <div className={cx(styles.RadioInput, horizontal && styles['RadioInput--horizontal'])}>
                {options.map((option, idx) => (
                    <label
                        className={!horizontal ?
                            cx(
                                styles.RadioInput__option,
                                idx === 0 && hasLabel && styles['RadioInput__option--isFirst'],
                                idx === 0 && !hasLabel && styles['RadioInput__option--isFirstNoLabel'],
                                idx === options.length - 1 && styles['RadioInput__option--isLast'],
                            ) :
                            cx(
                                styles.RadioInput__option,
                                styles['RadioInput__option--horizontal'],
                            )
                        }
                        htmlFor={`${input.name}-${valueStr(option.value)}`}
                        key={option.value}
                    >

                        <div className={styles.RadioInput__icon}>
                            <FontAwesomeIcon
                                icon={isSameValue(input.value, option.value) ? fasCircle : farCircle}
                            />
                        </div>

                        <input
                            className={styles.RadioInput__input}
                            id={`${input.name}-${valueStr(option.value)}`}
                            key={valueStr(option.value)}
                            type="radio"
                            {...input}
                            // value= musi byt az po {...input}
                            value={valueStr(option.value)}
                        />

                        {option.image && (
                            <Img
                                className={styles.RadioInput__image}
                                src={assetUrl + option.image}
                                height={20}
                                width={20}
                            />
                        )}

                        {option.label}
                    </label>
                ))}
            </div>
        );
    }
}

interface RadioControlPublicProps {
    label?: string;
    bottomBorder?: boolean;
    marginLeft?: boolean;
}

type RadioControlProps = RadioInputPublicProps & RadioControlPublicProps & WrappedFieldProps;

const RadioOptionsControl: React.StatelessComponent<RadioControlProps> = ({
    input, label, meta,                  // WrappedFieldProps
    bottomBorder, marginLeft,            // RadioControlPublicProps
    ...radioInputProps                   // RadioInputPublicProps
}) => (
    <FormControl
        label={label}
        bottomBorder={bottomBorder}
        marginLeft={marginLeft}
        input={input}
        meta={meta}
        minimizedLabel={true/* label is always minimized *//* tslint:disable-line */}
    >
        <RadioInput {...radioInputProps} hasLabel={!!label} input={input} />
    </FormControl>
);

type RadioFieldProps = RadioInputPublicProps & RadioControlPublicProps & {
    // see https://redux-form.com/7.3.0/docs/api/field.md/#props-you-can-pass-to-code-field-code-
    name: string;
};

class RadioField extends React.Component<RadioFieldProps> {
    public render() {
        return (
            <Field
                {...this.props}
                component={RadioOptionsControl}
                normalize={this.handleNormalize}
            />
        );
    }

    private handleNormalize = (value) => {
        const { options } = this.props;

        if (!options || !options.length) {
            return value;
        }

        // radio <input> ma hodnoty iba ako string. Najdi preto RadioOption, ktora je vybrata
        // a vrat jej value (moze to byt napr. cislo)
        const selected: RadioOption  = options.find((o) => isSameValue(o.value, value));
        return selected ? selected.value : value;
    };
}

export default RadioField;
